import { ListColumn, ListDataColumn } from "../ListColumn";
import { MedicinalProductsListView } from "./MedicinalProductsListView";

export class MAHsEntityListView extends MedicinalProductsListView {

        constructor(items: any) {

            const itemFinderArrayColumns=[
                new ListColumn("Num", ListDataColumn.TEXT, "num"),
                new ListColumn("EV Code", ListDataColumn.TEXT, "ev_Code"),
                new ListColumn("MAH Name", ListDataColumn.TEXT, "name_Org"),
                new ListColumn("Country", ListDataColumn.TEXT, "country"),
                new ListColumn("City", ListDataColumn.TEXT, "city"),
                new ListColumn("Address", ListDataColumn.TEXT, "address"),
                new ListColumn("Postcode", ListDataColumn.TEXT, "postcode"),
                new ListColumn("Validated", ListDataColumn.YESNODATETIME, "validated"),
                new ListColumn("Nullified", ListDataColumn.YESNODATETIME, "stamp_nullif")
            ];

            const itemFinderTreeColumns=[
                new ListColumn("EV Code", ListDataColumn.TEXT, "ev_Code"),
                new ListColumn("MAH Name", ListDataColumn.TEXT, "name_Org"),
                new ListColumn("Country", ListDataColumn.TEXT, "country"),
                new ListColumn("City", ListDataColumn.TEXT, "city"),
                new ListColumn("Address", ListDataColumn.TEXT, "address"),
                new ListColumn("Postcode", ListDataColumn.TEXT, "postcode"),
                new ListColumn("Validated", ListDataColumn.YESNODATETIME, "validated"),
                new ListColumn("Nullified", ListDataColumn.YESNODATETIME, "stamp_nullif")
            ];

            super(items,itemFinderArrayColumns,itemFinderTreeColumns);


    }

}